import { h, render } from 'preact';
import CartContext from './cart-context';
import Cart from './cart';
import Slider from '../slider';

export default (element, data) => {
  const renderCart = () => {
    render(
      <CartContext {...data}>
        <Cart {...data} />
      </CartContext>,
      element,
    );
  };

  const initStaticRecommendationsSlider = () => {
    const { recommendations: { isEnabled }} = data;
    if (!isEnabled) return;
    const container = element.querySelector('[data-minicart-recommended-slider]');

    // eslint-disable-next-line no-new
    new Slider({
      el: container,
      options: {
        slidesPerView: "auto",
        spaceBetween: 0,
        loop: false,
      },
    });
  
    // show content when it's ready
    container.classList.remove('sr-only');
  };

  const init = () => {
    renderCart();
    initStaticRecommendationsSlider();
  };

  init();
};
